export default __webpack_public_path__ + "static/media/cricket.543ebaf2.svg";